import type { AdminNumberSequenceRecord } from '../types';

interface NumberingFeatureProps {
  readonly sequences: readonly AdminNumberSequenceRecord[];
  readonly canManage: boolean;
  readonly busySequenceId: string | null;
  readonly onToggleActive: (sequenceId: string, active: boolean) => void;
}

function example(sequence: AdminNumberSequenceRecord): string {
  return `${sequence.prefix}${String(sequence.nextValue).padStart(sequence.sequenceLength, '0')}`;
}

export function NumberingFeature({
  sequences,
  canManage,
  busySequenceId,
  onToggleActive,
}: NumberingFeatureProps) {
  return (
    <section className="admin-feature" aria-labelledby="admin-numbering-title">
      <div className="admin-feature__heading">
        <div>
          <span className="admin-eyebrow">Nummernkreise</span>
          <h2 id="admin-numbering-title">Eindeutig, atomar und mandantenbezogen</h2>
        </div>
        <span className="admin-protected-badge">Vergabe erfolgt in der Datenbank</span>
      </div>

      <div className="admin-sequence-grid">
        {sequences.map((sequence) => (
          <article className={`admin-sequence ${sequence.active ? '' : 'is-disabled'}`} key={sequence.id}>
            <div className="admin-sequence__header">
              <div>
                <span className="admin-eyebrow">{sequence.key}</span>
                <h3>{sequence.label}</h3>
              </div>
              <label className="admin-switch">
                <input
                  type="checkbox"
                  checked={sequence.active}
                  disabled={!canManage || busySequenceId === sequence.id}
                  onChange={(event) => onToggleActive(sequence.id, event.target.checked)}
                />
                <span>{sequence.active ? 'Aktiv' : 'Inaktiv'}</span>
              </label>
            </div>
            <div className="admin-sequence__example">{example(sequence)}</div>
            <dl>
              <div><dt>Präfix</dt><dd>{sequence.prefix}</dd></div>
              <div><dt>Stellen</dt><dd>{sequence.sequenceLength}</dd></div>
              <div><dt>Nächster Zähler</dt><dd>{sequence.nextValue}</dd></div>
              <div><dt>Jahr</dt><dd>{sequence.year ?? 'fortlaufend'}</dd></div>
            </dl>
            <small>Erforderliches Recht: {sequence.requiredPermission}</small>
          </article>
        ))}
      </div>
      <p className="admin-hint">Präfixe und Zähler werden später nur über einen geprüften Änderungsdialog mit Vorschau, Sperrprüfung und Audit angepasst.</p>
    </section>
  );
}
